export const LicencedBanksGrid = [
    { field: 'id', headerName: '#', width: 75, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    { field: 'bankName', headerName: 'Emri Bankës', width: 600, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'stateName', headerName: 'Shteti', width: 600, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
]

